import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../core/state/user/user.model';

@Component({
  selector: 'app-pool-status',
  templateUrl: './pool-status.component.html',
  styleUrls: ['./pool-status.component.scss']
})
export class PoolStatusComponent implements OnInit {
  @Input() user: User;

  constructor() { }

  ngOnInit(): void {
  }

}
